import React from "react";
import { Layout } from "../../components";
import DetailHeader from "./DetailHeader";
import DetailList from "./DetailList";
import DetailPanelInfo from "./DetailPanelInfo";
import DetailPanelUpdate from "./DetailPanelUpdate";
import DetailPanelDownload from "./DetailPanelDownload";
import DetailPanelInstall from "./DetailPanelInstall";
import DetailPanelError from "./DetailPanelError";

const Detail = () => {
  const headerProps = {
    isZIndexTop: true,
    isTransparent: true,
    children: <DetailHeader />,
  };

  return (
    <Layout headerProps={headerProps}>
      <React.Fragment>
        <DetailList />
        <DetailPanelInfo />
        <DetailPanelUpdate />
        <DetailPanelDownload />
        <DetailPanelInstall />
        <DetailPanelError />
      </React.Fragment>
    </Layout>
  );
};

export default Detail;
